export const SECONDS_MS = 1000;
export const MINUTES_MS = SECONDS_MS * 60;
export const HOURS_MS = MINUTES_MS * 60;
export const DAY_MS = HOURS_MS * 24;
export const WEEK_MS = DAY_MS * 7;
export const HOUR_MINUTES = 60;
export const DAY_MINUTES = HOUR_MINUTES * 24;
